import { render, staticRenderFns } from "./fieldConfig.vue?vue&type=template&id=4cbf0950"
import script from "./fieldConfig.vue?vue&type=script&lang=js"
export * from "./fieldConfig.vue?vue&type=script&lang=js"
import style0 from "./fieldConfig.vue?vue&type=style&index=0&id=4cbf0950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports